export var RequestMethod;
(function (RequestMethod) {
    RequestMethod["POST"] = "post";
    RequestMethod["GET"] = "get";
    RequestMethod["PUT"] = "put";
    RequestMethod["DELETE"] = "delete";
})(RequestMethod || (RequestMethod = {}));
export class APICall {
    /**
     *
     * @param apiUrl api url
     * @param authToken x-auth-token token
     */
    constructor(apiUrl, authToken) {
        this.apiUrl = '';
        this.authToken = '';
        this.apiUrl = apiUrl;
        this.authToken = authToken;
    }
    /**
     *
     * @param request APIRequest
     */
    send(request) {
        return new Promise((resolve, reject) => {
            const { requestMethod, endpoint, data, searchParams, } = request;
            const options = {
                method: requestMethod,
                headers: {},
            };
            if (this.authToken) {
                options.headers['x-auth-token'] = this.authToken;
            }
            if (data) {
                options.headers['Content-Type'] = 'application/json';
                try {
                    options.body = JSON.stringify(data);
                }
                catch (error) {
                    reject(error);
                }
            }
            const url = new URL(`${this.apiUrl}/${endpoint}`);
            if (searchParams) {
                url.search = searchParams.toString();
            }
            fetch(url.toString(), options)
                .then((res) => res.json())
                .then((resData) => { resolve(resData); })
                .catch(resolve);
        });
    }
}
//# sourceMappingURL=APICall.js.map